/* eslint-disable camelcase */
import type { LanguageCode } from './language-code.model'
import {
  rbtvAdditionalLanguageCodes,
  redbullComAdditionalLanguageCodes,
} from './language-code.model'
import {
  cartoonsAdditionalLanguageCodes,
  supportedLanguageCodes,
} from './language-code.model'
import type { Space } from './space.model'
import { supportedSpaces } from './space.model'

const nonDefaultSpaceLanguages = [
  ...cartoonsAdditionalLanguageCodes,
  ...rbtvAdditionalLanguageCodes,
  ...redbullComAdditionalLanguageCodes,
] as readonly LanguageCode[]

const defaultSpaceLanguages = supportedLanguageCodes.filter(
  (code) => !nonDefaultSpaceLanguages.includes(code)
)

const cartoonsExcludedLanguages: LanguageCode[] = ['en-SE']

const brandBuildingEventsAdditionalLanguages: LanguageCode[] = [
  'ka-GE',
  'he-IL',
  'is-IS',
]

const specialLanguageRestrictionsPerSpace: Partial<Record<Space, LanguageCode[]>> = {
  'brand-building-events': [...brandBuildingEventsAdditionalLanguages, ...defaultSpaceLanguages],
  cartoons: [...cartoonsAdditionalLanguageCodes, ...defaultSpaceLanguages].filter((code) => !cartoonsExcludedLanguages.includes(code)),
  erc: ['en'],
  illume: ['en'],
  'pro-cycling': ['de', 'en'],
  rbtv: [...rbtvAdditionalLanguageCodes, ...defaultSpaceLanguages],
  'redbull-advancedtechnologies': ['en'],
  'redbull-f1academy': ['en'],
  'redbull-simracing': ['en'],
  redbull_com: [...redbullComAdditionalLanguageCodes, ...defaultSpaceLanguages],
  redbulletin: [
    'de',
    'de-AT',
    'de-CH',
    'de-DE',
    'en',
    'en-GB',
    'en-US',
    'fr',
    'fr-CH',
    'fr-FR',
  ],
  speedweek: ['de', 'en'],
  wrc: ['en'],
  wrcpromoter: ['en'],
  xalps: ['en'],
}

export const allowedLocalizationsPerSpace: Record<Space, LanguageCode[]> = {
  ...supportedSpaces.reduce((acc, space) => ({
    ...acc,
    [space]: specialLanguageRestrictionsPerSpace[space] || defaultSpaceLanguages,
  }), {}) as Record<Space, LanguageCode[]>,
}
